import React, {FC} from 'react';

import {UnreachableError} from '../../../../../libs/shared/core/src/helpers/types/customErrors';
import {ErrorBannerTypesEnum} from '../../../../../libs/shared/core/src/store/banners/commonBannerTypes';
import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {ErrorBannerState} from '../../../../store/panels/app/banners/bannersState';
import {AccountsErrorBannerContainer} from './accountsErrorBannerContainer';
import {ContactDetailsErrorBannerContainer} from './contactDetailsErrorBannerContainer';
import {HandoffErrorBannerContainer} from './handoffErrorBannerContainer';

/*
 * Props.
 */

interface ErrorBannersProps {
  panelId: AppPanelId;
  banners: ReadonlyArray<ErrorBannerState>;
}

/*
 * Component.
 */

export const ErrorBanners: FC<ErrorBannersProps> = (props) => (
  <>{props.banners.map((b) => renderErrorBanner(props.panelId, b))}</>
);

function renderErrorBanner(panelId: AppPanelId, banner: ErrorBannerState) {
  switch (banner.errorType) {
    case ErrorBannerTypesEnum.CONTACT_DETAILS:
      return (
        <ContactDetailsErrorBannerContainer key={`error-${banner.uid}`} panelId={panelId} state={banner} />
      );

    case ErrorBannerTypesEnum.ACCOUNTS:
      return <AccountsErrorBannerContainer key={`error-${banner.uid}`} panelId={panelId} state={banner} />;

    // This is handled in ContactsManagerBannersContainer so all the contacts manager banners are in one place.
    case ErrorBannerTypesEnum.CONTACTS_MANAGER:
      return null;

    case ErrorBannerTypesEnum.LENSES:
      return null;

    case ErrorBannerTypesEnum.ANALYTICS:
      return null;

    // Handled via its own handler.
    case ErrorBannerTypesEnum.KNOWLEDGE_BASE:
      return null;

    // This is handled in AccountsCsvImportBannersContainer so all the Accounts Csv Import banners are in one place.
    case ErrorBannerTypesEnum.ACCOUNTS_CSV_IMPORT:
      return null;

    case ErrorBannerTypesEnum.HANDOFF:
      return <HandoffErrorBannerContainer key={`error-${banner.uid}`} panelId={panelId} state={banner} />;

    default:
      throw new UnreachableError(banner);
  }
}
